/*eslint-disable prefer-const */
import { useEffect, useState, useDispatch } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Formik, Form, useFormik } from 'formik';
import * as yup from 'yup';
import TextInput from 'src/Components/GenericInputText/TextInput';
import GenericButton from 'src/Components/GenericButton/GenericButton';

import '../styles/edit-contact-info.scss';
//import { formatPhoneNumber, stateOptions } from 'src/utils';
import { axiosInstance } from '../../../../../api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import ToastMessage from '../../../common/ToastMessage/index';
//import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { toast } from 'react-toastify';

const validationSchema = yup.object({
  primary_email: yup
    .string()
    .email('Enter Valid Email Address')
    .required('Enter Email Address'),
});

const EditMemberContactInfo = ({
  onCancel,
  data,
  onSuccessfulSubmit,
  MemberEditPermissions,
  DependentEditPermissions,
  isMemberSelected,
  isDependentSelected,
  memberType,
}) => {
  console.log('********* >>>>>', data);
  //const { PhoneEmailInfo, residentialAddress, mailingAddress, dependentsData } =
  //data;
  let PhoneEmailInfo;

  PhoneEmailInfo = data?.PhoneEmailInfo;

  const [loader, setLoader] = useState(false);
  const [contactDetailsSaveSuccess, setContactDetailsSaveSuccess] =
    useState(false);

  useEffect(() => {
    if (contactDetailsSaveSuccess === true) {
      onSuccessfulSubmit();
    }
  }, [contactDetailsSaveSuccess]);

  const initialValues = {
    primary_email: PhoneEmailInfo.Email1,
  };
  const permissions =
    memberType?.memberType === 'Employee'
      ? MemberEditPermissions
      : DependentEditPermissions;
  //function to save Phone number and Alternate Email id
  const submitPhoneAndEmail = async (values) => {
    console.log('saving phone and email values >>>>>', values);
    //{{url}}/enrollment/updatemember/oid/4b83d022-6152-40e6-9696-24a3c98b465a/mailpapereob/N/alternateemail/new@E.mail/homephone/8251/mobilephone/8254/workphone/8027/userid/Liyaqatfour@gmail.com

    let urlToSubmit = '';

    //alternate_email, mobile_phone, home_phone, work_phone
    if (values.primary_email) {
      urlToSubmit += `email/${values.primary_email}`;
    }
    if (PhoneEmailInfo.Email1) {
      urlToSubmit += `/userid/${PhoneEmailInfo.Email1}`;
    }

    try {
      const response = await axiosInstance.put(
        `${APIEndpoints.updateMember()}${urlToSubmit}/oid/${
          data.selectedMember.ID
        }`,
      );
      setContactDetailsSaveSuccess(true);
      return response;
    } catch (error) {
      console.log('error occurred in updating member data', error);
    }
  };

  const handleSubmit = async (values) => {
    setLoader(true);
    console.log('reached......');
    //PhoneEmailInfo.Email1, PhoneEmailInfo.Email2, PhoneEmailInfo.CellPhone1, PhoneEmailInfo.HomePhone, PhoneEmailInfo.WorkPhone

    try {
      if (values.primary_email !== PhoneEmailInfo.Email1) {
        //await submitPhoneAndEmail(values);
        //toast.success(
        //<ToastMessage
        //type="success"
        //subTitle="Contact details submitted successfully."
        ///>,
        //);
        submitPhoneAndEmail(values)
          .then(() => {
            toast.success(
              <ToastMessage
                type="success"
                subTitle="Email saved successfully."
              />,
            );
            onSuccessfulSubmit();
          })
          .catch((e) => {
            toast.error(
              <ToastMessage
                type="error"
                subTitle="Some error occurred. Please try again later."
              />,
            );
          });
      }
    } catch (error) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Some error occurred. Please try again."
        />,
      );
    } finally {
      setLoader(false);
    }
  };
  const disableMember = permissions?.primaryEmail
    ? permissions?.editPrimaryEmail
    : false;
  //const handleCancelEdit = () => {
  //console.log('reached......');
  ////setcancelEdit(!cancelEdit);
  //onCancel();
  //};
  //eslint-disable-next-line no-debugger
  //debugger;
  return (
    <Container className="edit-member-contact-info p-0">
      <div className="my-profile-member-container">
        <div>
          <h2 className="row-title" tabIndex={0}>
            Contact Information
          </h2>
        </div>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          //submitPhoneAndEmail(values);
          handleSubmit(values);
        }}
        validateOnChange
        validateOnBlur
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          setFieldValue,
        }) => {
          console.log('errors >>>>> ', errors);
          return (
            <Form onSubmit={handleSubmit}>
              <Row className="form-main-container m-0">
                {/*primary email */}
                <Col md={12} className="form-input-row">
                  <TextInput
                    label={'Email'}
                    isRequired
                    inputProps={{
                      id: 'primary-email-edit',
                      placeholder: 'Primary Email',
                      value: values.primary_email,
                      name: 'primary_email',
                      onChange: (e) => {
                        handleChange(e);
                      },
                      //readOnly: true,
                      disabled:
                        memberType?.memberType === 'Employee'
                          ? !disableMember
                          : true,
                    }}
                    feedBackMessage={
                      errors.primary_email ? errors.primary_email : null
                    }
                  />
                </Col>
                <Col
                  md={12}
                  className="form-input-row d-flex justify-content-end"
                >
                  <div className="text-right">
                    <GenericButton type="submit" onClick={handleSubmit}>
                      Update
                    </GenericButton>
                    {/*<GenericButton variant={'link'} onClick={handleCancelEdit}>
                      Cancel
                    </GenericButton>*/}
                  </div>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

export default EditMemberContactInfo;
